/* global YT */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import scrollIntoView from 'scroll-into-view';
import * as actions from './actions';
import App from '../app';
import LazyLoad from 'react-lazyload';
import ProductItem from '../productItem';
import AppleStoreIcon from 'images/apple-store-icon.png';
import GooglePlayIcon from 'images/google-play-icon.png';
import { display } from 'shared/models/address';
import config from 'sharedConfig';
import { AsyncLeadCaptureModal } from 'components/async';

class Storefront extends React.Component {
  constructor() {
    super();
    this.state = { showVideo: false };
    this.featuredBanner = config.featuredBanners && config.featuredBanners.home;
    this.scrollToContent = this.scrollToContent.bind(this);
  }

  componentDidMount() {
    // TODO: make this conditional on address change
    this.props.featuredProducts();
  }

  componentDidUpdate(prevProps) {
    const zipHasChanged = this.props.address.zip !== prevProps.address.zip;
    const addressHasChanged =
      display(this.props.address) !== display(prevProps.address);
    if (zipHasChanged || addressHasChanged) {
      this.props.featuredProducts();
    }
  }

  scrollToContent(e) {
    e.preventDefault();
    const featuredSection = document.getElementById('featured');
    const offset = window.innerWidth < 768 ? 120 : 150;
    scrollIntoView(featuredSection, { align: { top: 0, topOffset: offset } });
  }

  showVideo() {
    if (!this.loadingYT) {
      this.loadingYT = true;
      var self = this;
      var tag = document.createElement('script');
      tag.setAttribute('async', '');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.onYouTubeIframeAPIReady = () => {
        self.player = new YT.Player('player', {
          height: '390',
          width: '640',
          videoId: 'c8Qdfv8mfpE',
          events: {
            onReady: event => {
              if (self.state.showVideo) event.target.playVideo();
            }
          }
        });
      };
    }
    this.setState({ showVideo: true });
    if (this.player && typeof this.player.playVideo == 'function')
      this.player.playVideo();
  }

  hideVideo() {
    this.setState({ showVideo: false });
    this.player.stopVideo();
  }

  render() {
    return (
      <App pageName="Homepage">
        <div className="home banner-padding">
          {this.props.address.shipping ? (
            <div className="banner banner--shipping">
              <div className="banner-info banner-info--shipping">
                <h1>
                  Free Shipping On Orders Over ${config.shipping.freeThreshold}
                </h1>
                <span>Buying alcohol has never been easier</span>
              </div>
              <div id="app-links">
                <div id="app-imgs">
                  <a href="https://app.adjust.io/fd9883">
                    <img src={AppleStoreIcon} />
                  </a>
                  <a href="https://app.adjust.io/yjmtnf">
                    <img src={GooglePlayIcon} />
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="banner">
              <div className="banner-info">
                <h1>30-Minute Alcohol Delivery</h1>
                <span>Spend life with friends... not in liquor stores.</span>
                <a
                  href="#featured"
                  onClick={this.scrollToContent}
                  className="button btn-primary green hover-shadow"
                >
                  Start Shopping Now
                </a>
              </div>
              <span id="how-it-works" onClick={this.showVideo.bind(this)}>
                <i className="icon-play-btn" />
                How it works
              </span>
              <div
                className={this.state.showVideo ? 'display-video' : ''}
                id="video-container"
              >
                <span className="close" onClick={this.hideVideo.bind(this)}>
                  x
                </span>
                <div id="player" />
              </div>
              <div id="app-links">
                <div id="now-serving">
                  <strong>NOW SERVING</strong>
                  <div>
                    <a
                      className="city-link"
                      href="/cities/alcohol-delivery-los-angeles/"
                    >
                      LA
                    </a>{' '}
                    |{' '}
                    <a
                      className="city-link"
                      href="/cities/alcohol-delivery-san-francisco/"
                    >
                      SF
                    </a>{' '}
                    |{' '}
                    <a
                      className="city-link"
                      href="/cities/alcohol-delivery-san-diego/"
                    >
                      SD
                    </a>{' '}
                    |{' '}
                    <a
                      className="city-link"
                      href="/cities/alcohol-delivery-chicago/"
                    >
                      CHI
                    </a>{' '}
                    |{' '}
                    <a
                      className="city-link"
                      href="/cities/alcohol-delivery-sacramento/"
                    >
                      SAC
                    </a>{' '}
                    |{' '}
                    <a
                      className="city-link"
                      href="/cities/alcohol-delivery-oakland/"
                    >
                      OAK
                    </a>
                  </div>
                </div>
                <div id="app-imgs">
                  <a href="https://app.adjust.io/fd9883">
                    <img src={AppleStoreIcon} />
                  </a>
                  <a href="https://app.adjust.io/yjmtnf">
                    <img src={GooglePlayIcon} />
                  </a>
                </div>
              </div>
            </div>
          )}

          <section id="featured">
            <div id="cat-container" className="row">
              {this.props.categories.map(item => (
                <div className="col-lg-2 col-xs-4 section" key={item.title}>
                  <Link to={item.url}>
                    <LazyLoad height={80} once={true} offset={100}>
                      <img alt={item.title} src={item.image} />
                    </LazyLoad>
                    {item.title}
                  </Link>
                </div>
              ))}
            </div>
            <div className="row products home-product-padding">
              <div className="col-xs-12 col-lg-12 products-header">
                <Link to="/spirits">
                  View More <span className="icon-arrow-right" />
                </Link>
                <h2>Hot Items</h2>
              </div>
              {this.props.products.map(item => (
                <ProductItem
                  className="col-xs-6 col-sm-4 col-md-3 col-lg-2 section first"
                  trackCategory="Home - Featured"
                  {...item}
                  key={item.sku_id}
                />
              ))}
            </div>
            {!!this.featuredBanner && (
              <div id="featured-banner">
                <Link to={this.featuredBanner.link}>
                  <img src={this.featuredBanner.image} width="100%" />
                </Link>
              </div>
            )}
          </section>

          <div id="blogs">
            <div className="divider-title">
              <div className="divider-title-line">
                <hr />
              </div>
              <div className="divider-title-text">
                <a href="/blog" target="_blank">
                  <h2>Saucey Reading Room</h2>
                </a>
              </div>
              <div className="divider-title-line">
                <hr />
              </div>
            </div>
            <div className="row">
              {this.props.blogs.map(item => (
                <div
                  key={item.title}
                  className="col-xs-6 col-sm-3 col-md-3 col-lg-3"
                >
                  <a className="column" href={item.link} target="_blank">
                    <div
                      className="blog-image"
                      style={{ backgroundImage: `url(${item.image})` }}
                    />
                    <div className="blog-summary">
                      <h6>{item.title}</h6>
                      {/* <p>{item.date}</p> */}
                      <p>{item.content}</p>
                      {/* <div className="divider"></div> */}
                      <span>Continue Reading</span>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>

          <AsyncLeadCaptureModal />
        </div>
      </App>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.home,
    address: state.address,
    experiments: state.app.experiments
  };
}

export default connect(mapStateToProps, { ...actions })(Storefront);



// WEBPACK FOOTER //
// ./shared/components/home/storefront.js